<template>
  <div class="field" :class="{ 'has-addons': hasDateValue }">
    <b-datepicker
      ref="datepicker"
      :icon="icon"
      :placeholder="placeholder"
      :month-names="monthNames"
      :day-names="weekDaysShortNames"
      v-model="dateValue"
      :years-range="[2015 - new Date().getFullYear(), 10]"
      expanded
      :disabled="readOnly"
    />
    <b-button
      v-if="nullable && hasDateValue"
      @click="dateValue = null"
      type="is-link"
      icon-left="times"
      style="border-radius: 0 4px 4px 0"
    />
  </div>
</template>

<script>
import i18n from '@/helpers/i18n'
import dayjs from 'dayjs'

export default {
  props: {
    placeholder: String,
    icon: String,
    value: String,
    nullable: Boolean,
    readOnly: Boolean
  },
  computed: {
    dayjsLocale() {
      // On utilise la réactivité de la locale de l'application
      if (i18n.locale()) {
        return dayjs().$locale()
      }
      return null
    },
    monthNames() {
      if (!this.dayjsLocale) return []
      return this.dayjsLocale.months
    },
    weekDaysShortNames() {
      if (!this.dayjsLocale) return []
      return this.dayjsLocale.weekdays.map((d) => d.substring(0, 2))
    },
    hasDateValue() {
      return !!this.dateValue
    },
    dateValue: {
      get() {
        if (!this.value) return null
        return i18n.dayjs(this.value).toDate()
      },
      set(val) {
        this.$emit('input', val ? val.toISOString() : null)
      }
    }
  }
}
</script>